export default {"src":"/_next/static/media/send_email.be4be2d2.svg","height":397,"width":762,"blurWidth":0,"blurHeight":0};